import { gql } from 'apollo-boost';

export const DOWNLOAD_REDDIT_JSON_DUMP = gql`
    mutation($data: DownloadUrlInfoDumpInput!) {
        downloadRedditJsonDump(data: $data) {
            url
            name
            displayName
            type
            format
            size
            mime
        }
    }
`;
